import type { AvailableLanguages } from "~/src/api";
import fonts from "./fonts.json";
import fontSheet from "./font-sheet.json";

export const FontSheet = fontSheet as unknown as Record<
  string,
  {
    text: string;
    font_family?: string;
    link?: string;
    baseFontRatio?: number;
  }
>;

export const getFontFamily = (
  appearance?: string,
  language: AvailableLanguages = "en",
) => {
  if (!language || !appearance) return undefined;

  const fontFamily =
    fontMapping[language][
      appearance as keyof (typeof fontMapping)[AvailableLanguages]
    ];
  if (fontFamily)
    return {
      ...FontSheet[fontFamily],
      value: fontFamily,
    };
  return undefined;
};

const fontMapping = fonts as unknown as Record<
  AvailableLanguages,
  {
    sans: string;
    serif: string;
    monospace: string;
    cursive: string;
    fantasy: string;
  }
>;

export interface NovelStyleTemplate {
  name?: string;
  bold: boolean;
  justify: boolean;
  fontFamily: string;

  // use style sheets to control colors, i.e. background and text
  // dark is applied through tailwind, so check for .dark .<styleClass>
  styleClass: string;
  readerStyleClass?: string;

  fontRatio?: number;
  letterSpacing?: number;
  wordSpacing?: number;
  lineHeight?: number;
}

export const getNovelReaderFontsForLanguage = (lang: AvailableLanguages) => {
  const langFonts = Object.entries(fontMapping[lang]);
  return langFonts.map(([appearance, font]) => {
    const mapping = FontSheet[font];
    return {
      ...mapping,
      value: `"${font}", ${mapping?.font_family}`,
      appearance: `fonts.appearance.${appearance}`,
    };
  });
};
